import { DelioLabels } from "./class/DelioLabels";
import { Globals } from "./globals/variables";
import { initReplacePhone } from "./utils/replacePhone.js";
import { checkLabelsUpdate } from "./utils/checkLabelsUpdate.js";

(async () => {
  if (typeof DFI_client !== "object") {
    var DFI_client = {};
  }

  if (typeof DFI !== "object") {
    globalThis.DFI = {};
  }

  globalThis.DFI_client = DFI_client;

  const delioLabels = new DelioLabels();
  globalThis.digitalData = delioLabels.getDigitalData();

  //Telefono por defecto
  globalThis.DFI_client.defaultPhoneUnailable = "210200021";
  globalThis.DFI_client.defaultPhone = "210200021";

  // si estamos en endesa o en planoamigo que no cargue ringpool
  if (
    window.location.host == "www.endesa.pt" ||
    window.location.host == "planoamigoendesa.pt"
  ) {
    globalThis.DFI.tempNotInterferePhone = true;
  }

  delioLabels.loadDelioLibs(Globals.DelioOneClick.init, Globals.idTagD1C);

  initReplacePhone();
  checkLabelsUpdate();
})();
